module.exports = __webpack_public_path__ + "assets/media/dolmen-day.3b25fcc1.ogg";